import {
  Paper,
  Select,
  Textarea,
  ActionIcon,
  Stack,
  NumberInput,
  Group,
} from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { BuilderQuestion, QuestionType } from "@/types/interview.types";

interface QuestionItemProps {
  question: BuilderQuestion;
  onChange: (updates: Partial<BuilderQuestion>) => void;
  onRemove: () => void;
}

const questionTypeOptions = [
  { value: "open-ended", label: "Open-ended" },
  { value: "number-scale", label: "Number scale" },
];

export function QuestionItem({
  question,
  onChange,
  onRemove,
}: QuestionItemProps) {
  return (
    <Paper className="question-item" p="md" radius="md" withBorder>
      <ActionIcon
        className="remove-question-btn"
        variant="outline"
        color="red"
        size="sm"
        onClick={onRemove}
      >
        <IconX size={14} />
      </ActionIcon>

      <Stack gap="md">
        <div className="field-and-label-wrapper">
          <Select
            label="Question type"
            data={questionTypeOptions}
            value={question.type}
            onChange={(value) =>
              onChange({ type: (value as QuestionType) || "open-ended" })
            }
          />
        </div>

        <div className="field-and-label-wrapper">
          <Textarea
            label="Question text"
            placeholder="Enter your question here..."
            minRows={3}
            value={question.text}
            onChange={(e) => onChange({ text: e.currentTarget.value })}
          />
        </div>

        <Group>
          <NumberInput
            label="Max follow-ups"
            description="Number of follow-up questions allowed (0-3)"
            value={question.maxFollowups}
            onChange={(value) =>
              onChange({ maxFollowups: typeof value === "number" ? value : 1 })
            }
            min={0}
            max={3}
            step={1}
            decimalScale={0}
            style={{ width: 180 }}
          />
        </Group>
      </Stack>
    </Paper>
  );
}
